import { Button, Pagination, Space, Table, Tooltip, Modal, Input, Upload, Select, Checkbox, Form, Tag, notification, Row, Col, Switch, Progress } from "antd";
import { useEffect, useRef, useState } from "react";
import { EditOutlined, DeleteOutlined, UploadOutlined, SearchOutlined } from "@ant-design/icons";
import videoService from "../../../services/video-service";
import dayjs from "dayjs";
import { changeDocumentTitle } from "../../../utils/title";

function Video() {
    const [pagination, setPagination] = useState({
        current: 1,
        total: 0,
        pageSize: 10,
    });
    const [search, setSearch] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [video, setVideos] = useState([])
    const [file, setFile] = useState(null);
    const [form] = Form.useForm();
    const [editingId, setEditingId] = useState(null);
    const [data, setData] = useState([])
    const [isModalShow, setIsModalShow] = useState(false)
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgress, setShowProgress] = useState(false);
    const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const progressInterval = useRef(null);

    const handleUpload = (info) => {
        if (info.file) {
            setFile(info.file);   // save file to state
        }
    };
    const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
        setLoading(true);
        const { success, data, message } = await videoService.fetch(page, pageSize, search);
        console.log("data", data)
        setLoading(false);
        if (success) {
            setVideos(data.data);
            setPagination((prev) => ({
                ...prev,
                total: data.total,
                current: page,
                pageSize,
            }));
        } else {
            console.error(`Error fetching vendors: ${message || "Unknown error"}`);
        }
    };

    const onFinish = async (values) => {
        setLoading(true);
        setShowProgress(true);
        setUploadProgress(0);

        const formData = new FormData();
        if (editingId) formData.append('_method', 'PUT');

        Object.entries({
            ...values,
            is_active: values.is_active ? 1 : 0,
            video: file
        }).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                formData.append(key, value);
            }
        });

        let progress = 0;

        // 🔥 Start smooth animation
        progressInterval.current = setInterval(() => {
            if (progress < 99) {
                progress += 1;
                setUploadProgress(progress);
            }
        }, 30);

        try {
            const response = editingId
                ? await videoService.update(editingId, formData)
                : await videoService.add(formData);

            // 🛑 Stop fake animation
            clearInterval(progressInterval.current);

            // 🔥 Smooth finish to 100
            const finishProgress = () => {
                return new Promise((resolve) => {
                    const finishInterval = setInterval(() => {
                        setUploadProgress((prev) => {
                            if (prev >= 100) {
                                clearInterval(finishInterval);
                                resolve();
                                return 100;
                            }
                            return prev + 2;
                        });
                    }, 20);
                });
            };

            await finishProgress(); // wait until reaches 100

            await new Promise((r) => setTimeout(r, 300)); // small delay for UX

            if (response.success) {
                notification.success({
                    message: "Success",
                    description: editingId
                        ? "Video updated successfully!"
                        : "Video added successfully",
                    placement: "topRight",
                });

                initialize();
                setEditingId(null);
                form.resetFields();
                setFile(null);
            }

            setShowProgress(false);
            setUploadProgress(0);
            setIsModalOpen(false); // 🔥 CLOSE AFTER 100%
            setLoading(false);

        } catch (error) {
            clearInterval(progressInterval.current);
            setShowProgress(false);
            setUploadProgress(0);
            setLoading(false);
        }
    };
    const handleEdit = (record) => {
        form.setFieldsValue({
            title: record.title,
            description: record.description,
            audience: record.is_for_customer ? "customer" : "staff",
            is_active: record.is_active ? 1 : 0,
        });
        // setData({
        //     ...record,
        //     video_url: record.video_url, // always update before opening modal
        // });
        setData(record)
        setEditingId(record.id); // <<< store id for updating
        setIsModalOpen(true);
    };

    const columns = [
        { title: "#", dataIndex: "id", key: "id" },
        { title: "Title", dataIndex: "title", key: "title" },
        {
            title: "URL", dataIndex: "video_url", key: "video_url", render: (text) => (
                <a href={text} target="_blank" rel="noopener noreferrer">
                    <Button variant="outlined" color="primary"
                        style={{
                            transition: "0.3s",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#B83D3D";
                            e.currentTarget.style.color = "#fff";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "";
                            e.currentTarget.style.color = "";
                        }}>Watch</Button>
                </a>)
        },
        { title: "Description", dataIndex: "description", key: "description" },
        {
            title: "Status", dataIndex: "is_active", key: "is_active", render: (text, record) =>
                <Tag color={record?.is_active === 1 ? "green" : 'red'}>{record?.is_active === 1 ? "Active" : 'Inactive'}</Tag>
        },
        {
            title: "Audience", dataIndex: "audience", key: "audience", render: (text, record) =>
                (record?.is_for_customer ? <Tag color="geekblue"> Customer</Tag> : <Tag color="gold"> Staff</Tag>)
        },
        {
            title: "created At", dataIndex: "created_at", key: "created_at", render: (text) =>
                dayjs(text).format("DD-MM-YYYY , hh:mm A")
        },
        {
            title: "Updated At", dataIndex: "updated_at", key: "updated_at", render: (text) =>
                dayjs(text).format("DD-MM-YYYY , hh:mm A")
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (text, record) => (
                <Space size="small">
                    <Tooltip title="Edit" onClick={() => handleEdit(record)}>
                        <EditOutlined />
                    </Tooltip>

                    <Tooltip title="Delete" onClick={() => {
                        setSelectedDeleteRecord(record);
                        setIsModalShow(true);
                    }}>
                        <DeleteOutlined />
                    </Tooltip>
                </Space>
            ),
        },
    ];
    const handleOk = async () => {
        setLoading(true)
        if (!selectedDeleteRecord) return;
        const response = await videoService.delete(selectedDeleteRecord.id);
        setLoading(false)
        if (response?.success) {
            setVideos((prevData) =>
                prevData.filter((item) => item.id !== selectedDeleteRecord.id)
            );
            initialize();
            notification.success({
                message: "Success",
                description: "Video deleted successfully!",
                placement: "topRight",
            });
        } else {
            const errors = response.data?.errors || [response.message];
            notification.error({
                message: "Error",
                description: `Error: ${errors.join(", ")}`,
                placement: "topRight",
            });
        }

        setIsModalShow(false);
    };
    const deleteModal = (
        <Modal
            title={<div style={{ textAlign: "center" }}>Confirm</div>}
            open={isModalShow}
            onOk={handleOk}
            onCancel={() => setIsModalShow(false)}
            centered
            style={{
                padding: "20px", // Adjust padding for smaller size
            }}
            width={350} // Adjust modal width
            footer={
                <div className="flex justify-center gap-3">
                    <Button type="default"
                        onClick={() => setIsModalShow(false)}
                    >
                        Cancel
                    </Button>
                    <Button type="primary" onClick={handleOk}
                        loading={loading}>
                        Confirm
                    </Button>
                </div>
            }
        >
            <p style={{ textAlign: "center" }}>
                Are you sure you want to delete this?
            </p>
        </Modal>

    )

    const modal = (
        <Modal
            title={editingId ? "Edit Video" : "Add New Video"}
            open={isModalOpen}
            onCancel={() => {
                setIsModalOpen(false)
                setEditingId(null);
                form.resetFields();
            }}
            width={"50%"}
            footer={null}
        >
            <Form layout="vertical" onFinish={onFinish} form={form}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Title" name='title'>
                            <Input
                                placeholder="Enter video title"
                                className="mb-3"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Audience" name='audience' initialValue="customer">
                            <Select
                                className="w-full"
                                options={[
                                    { label: "Customer", value: "customer" },
                                    { label: "Staff", value: "staff" },
                                ]}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        {editingId && data?.video_url && (
                            <Form.Item label="Current Video">
                                <video width={850} controls key={data.video_url}>
                                    <source src={data.video_url} />
                                </video>
                            </Form.Item>
                        )}
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Upload Video" name="video" className="m-0 p-0">
                            <Upload
                                beforeUpload={() => false}
                                showUploadList={true}
                                accept="video/*"
                                onChange={handleUpload}
                            >
                                <Button icon={<UploadOutlined />} className="mb-0">
                                    Click to Upload
                                </Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name="is_active"
                            valuePropName="checked"
                            initialValue={true}
                        >
                            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                        </Form.Item>
                    </Col>

                    <Col span={24} >
                        {/* Description */}
                        <Form.Item label="Description" name='description' >
                            <Input.TextArea
                                rows={4}
                                placeholder="Enter description"
                            />
                        </Form.Item>
                    </Col>


                    <Col span={24}>
                        <div className="flex  gap-2 justify-betweeen">
                            {showProgress && (
                                <Progress
                                    percent={uploadProgress}
                                    status={uploadProgress < 100 ? "active" : "normal"}
                                    strokeWidth={18}                 // 🔥 height increase
                                    strokeColor="#B83D3D"
                                />
                            )}

                            <div className="flex gap-3">
                                <Button onClick={() => setIsModalOpen(false)}>
                                    Cancel
                                </Button>
                                <Button htmlType="submit" type="primary" loading={loading}>
                                    Save
                                </Button>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Form>
        </Modal>
    )
    useEffect(() => {
        changeDocumentTitle("Videos");
        initialize(pagination.current, pagination.pageSize, search);
    }, [search]);
    return (
        <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>
            <div className="flex justify-end p-2 gap-3">
                <Input
                    placeholder="Search by Title"
                    prefix={<SearchOutlined />}
                    style={{
                        width: "25%",
                        borderRadius: "20px",
                        fontSize: 14,
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <Button type="primary" onClick={() => setIsModalOpen(true)}>
                    Add new Video
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={video}
                pagination={false}
                style={{ marginTop: "10px" }}
                loading={loading}
                footer={() => (
                    <div className="flex justify-between items-center text-xs">
                        <div className="text-gray-600">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                            {pagination.total} entries
                        </div>
                        <Pagination
                            current={pagination.current}
                            total={pagination.total}
                            pageSize={pagination.pageSize}
                            showSizeChanger={false}
                            onChange={(page) => initialize(page, pagination.pageSize, search)}
                            itemRender={(current, type, originalElement) => {
                                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                return originalElement;
                            }}
                        />
                    </div>
                )}
            />
            {modal}
            {deleteModal}
        </div >
    );
}

export default Video;
